const getDayIndex = (date) => {
  const x = date ? new Date(date) : new Date();
  return x.getDay() === 0
    ? 7
    : x.getDay()
}

export default getDayIndex;